/**
 * src/lib/api/people.js — People read API.
 * Returns raw snake_case user_profiles rows. See docs/SHAPE_CONTRACT.md.
 */

import { supabase } from '../supabase';

export async function fetchPeople() {
  try {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('id, display_name, email, role, airtable_person_id, weekly_hours_target, archived_at')
      .order('display_name');
    if (error) { console.warn('[people] fetch error:', error.message); return []; }
    return data || [];
  } catch (err) {
    console.warn('[people] fetchPeople failed:', err.message);
    return [];
  }
}

// Alias for legacy callers
export const loadPeople = fetchPeople;
